import { render, staticRenderFns } from "./orderStatement.vue?vue&type=template&id=77b967fb&scoped=true"
import script from "./orderStatement.vue?vue&type=script&lang=js"
export * from "./orderStatement.vue?vue&type=script&lang=js"
import style0 from "./orderStatement.vue?vue&type=style&index=0&id=77b967fb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b967fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b967fb')) {
      api.createRecord('77b967fb', component.options)
    } else {
      api.reload('77b967fb', component.options)
    }
    module.hot.accept("./orderStatement.vue?vue&type=template&id=77b967fb&scoped=true", function () {
      api.rerender('77b967fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statement/orderStatement.vue"
export default component.exports